{"name": "nextgen-bitbrew-web", "buildversion": "1.0.14_11052026-085541", "buildTime": "05/11/2026 08:55:41"}